import sanitize from 'sanitize-filename';

export default function sanitizeFilename(filename: string) {
  const sanitized = sanitize(filename);

  return sanitized.trim().replace(/#/g, '');
}
